import { Controller } from "@hotwired/stimulus"

// The Posts and Stories tabs of a creator's page (28 Oct 2026): the filters
// above the map (place_filters_controller) send the places still listed, and
// a post or a story shows while one of its places is among them. Each tab
// (data-kind) counts its own.
//
// Thirty at a time (Stéphane): the next thirty when the foot of the grid
// comes into view. The tiles are all in the page — a filter stays instant —
// but a hidden one loads no picture (loading=lazy).
const PAGE = 30

export default class extends Controller {
  static targets = ["item", "empty", "more"]

  connect() {
    this.ids = null
    this.limits = {}
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const kind = entry.target.dataset.kind
        this.limits[kind] = this.limit(kind) + PAGE
        this.render()
      })
    }, { rootMargin: "400px" })
    this.moreTargets.forEach((more) => this.observer.observe(more))
    this.render()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  filter(event) {
    this.ids = new Set(event.detail.ids)
    this.limits = {}
    this.render()
  }

  limit(kind) {
    return this.limits[kind] || PAGE
  }

  render() {
    const matched = {}
    this.itemTargets.forEach((item) => {
      const kind = item.dataset.kind
      const on = !this.ids || item.dataset.venues.split(" ").some((id) => this.ids.has(id))
      const rank = on ? (matched[kind] = (matched[kind] || 0) + 1) : 0
      item.classList.toggle("hidden", !on || rank > this.limit(kind))
    })
    this.emptyTargets.forEach((empty) => empty.classList.toggle("hidden", (matched[empty.dataset.kind] || 0) > 0))
    this.moreTargets.forEach((more) => more.classList.toggle("hidden", (matched[more.dataset.kind] || 0) <= this.limit(more.dataset.kind)))
    if (!this.ids) return
    Object.entries(matched).forEach(([kind, n]) => {
      const count = this.element.querySelector(`[data-tab-count=${kind}]`)
      if (count) count.textContent = n
    })
    this.element.querySelectorAll("[data-tab-count]").forEach((count) => {
      if (count.dataset.tabCount !== "places" && !(count.dataset.tabCount in matched)) count.textContent = 0
    })
  }
}
